<template>
  <AppMainDialogForm
    v-model="dialog"
    :isLoading="isLoading"
    size="800"
    :tituloTela="tituloTela"
    :tooltip="tooltip"
    @initComponent="initComponent"
    @saveRegistro="saveRegistro"
    @cancel="cancel"
  >
    <v-form v-model="isFormValid" ref="form">
      <v-layout row justify-center>
        <v-flex class="item" xs4 md4>
          <v-text-field
            :rules="[campoObrigatorio, campoCPFouCNPJ]"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            v-model.trim="registro.nrDocumento"
            label="CPF/CNPJ"
            outlined
            clearable
          >
          </v-text-field>
        </v-flex>
        <v-flex class="item" xs7 md7>
          <v-text-field
            :rules="[campoObrigatorio]"
            v-model.trim="registro.nmProdutor"
            label="Nome"
            outlined
            clearable
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-flex class="item" xs4 md4>
          <v-text-field
            v-mask="maskCel"
            v-model="registro.nrTelefone"
            label="Celular"
            outlined
            clearable
          >
          </v-text-field>
        </v-flex>
        <v-flex class="item" xs7 md7>
          <v-text-field
            v-model="registro.dsEmail"
            :rules="[campoEmail]"
            label="E-mail"
            outlined
            clearable
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row justify-start pa-0 pl-8>
        <v-flex class="item" xs4 md4>
          <v-checkbox
            style="margin: 0px;"
            v-model="registro.stPossuiUsuario"
            label="Usuário acessa o Aplicativo"
          ></v-checkbox>
        </v-flex>
        <v-flex class="item" xs3 md5>
          <v-btn
            @click="resetSenha"
            v-if="registro.stPossuiUsuario && registro.idKeycloak"
            rounded
            color="#ff542969"
          >
            <span> Resetar senha do usuário </span>
          </v-btn>
        </v-flex>
        <v-flex class="item" xs4 md4>
          <v-spacer />
        </v-flex>
      </v-layout>
    </v-form>
  </AppMainDialogForm>
</template>

<script>
import {
  campoObrigatorio,
  campoCPFouCNPJ,
  campoSelectObrigatorio,
  campoEmail,
} from "@/filters/rules";

import AppMainDialogForm from "@/components/layout/AppMainDialogForm.vue";
import { mask } from "vue-the-mask";

export default {
  components: {
    AppMainDialogForm,
  },
  directives: {
    mask,
  },
  data() {
    return {
      tooltip: "Novo Produtor",
      tituloTela: "Cadastro de Produtor",
      isFormValid: true,
      isLoading: false,
      isInserting: true,
      registro: {
        dsEmail: null,
        stPossuiUsuario: false,
      },
      maskCPF: ["###.###.###-##", "##.###.###/####-##"],
      maskCel: "(##)#####-####",
    };
  },
  computed: {
    urlAPIEstabelecimento() {
      return this.$store.state.urlAPIEstabelecimento;
    },
  },
  methods: {
    campoObrigatorio,
    campoCPFouCNPJ,
    campoSelectObrigatorio,
    campoEmail,
    initComponent() {
      this.$emit("openDialog");
      var produtor = {};
      if (this.rec.idProdutor != undefined) {
        produtor = this.rec;
        this.isInserting = false;
      } else {
        if (this.$refs.form != undefined) {
          this.$refs.form.reset();
        }
        this.isInserting = true;
        produtor = {
          dsEmail: null,
          stPossuiUsuario: false,
        };
      }
      this.registro = Object.assign({}, produtor);
    },
    saveRegistro() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        if (this.isInserting) {
          this.insertRegistro();
        } else {
          this.updateRegistro();
        }
      }
    },
    insertRegistro() {
      this.registro.dsEmail =
        this.registro.dsEmail == "" ? null : this.registro.dsEmail;
      this.registro.cdEstabelecimento = this.idEstabelecimento;
      this.$axios
        .post(
          this.urlAPIEstabelecimento + "produtor/",
          this.registro
        )
        .then((response) => {
          this.$emit("inserted", response.data);
          this.$emit("closeDialog");
        })
        .catch((error) => {
          this.$store.commit("setSnack", { type: "error", msg: error });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateRegistro() {
      this.registro.dsEmail =
        this.registro.dsEmail == "" ? null : this.registro.dsEmail;
      this.$axios
        .put(
          this.urlAPIEstabelecimento +
            "produtor/" +
            this.registro.idProdutor,
          this.registro
        )
        .then((response) => {
          this.$emit("updated", response.data);
          this.$emit("closeDialog");
        })
        .catch((error) => {
          this.$store.commit("setSnack", { type: "error", msg: error });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    cancel() {
      this.$emit("closeDialog");
    },
    resetSenha() {
      this.$axios
        .put(
          this.urlAPIEstabelecimento +
            "produtor/resetSenha/" +
            this.registro.idProdutor
        )
        .then(() => {
          this.$emit("closeDialog");
          this.$store.commit("setSnack", {
            type: "success",
            msg: "Senha alterada com sucesso!",
          });
        })
        .catch((error) => {
          this.$store.commit("setSnack", { type: "error", msg: error });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  props: {
    idEstabelecimento: Number,
    dialog: {
      type: Boolean,
      default: false,
    },
    rec: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.initComponent();
      }
    },
  },
};
</script>

<style scoped>
.item {
  margin: 1px;
}
</style>
